<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
/* Poți adăuga stiluri globale aici */
</style>
